// Tiny Web Audio bell used together with the Landing-page confetti burst.
// Renders two soft sine notes (C6 + E6) with quick attack and long decay
// so the moment feels celebratory without being loud.
//
// The mute preference is persisted in localStorage so the user's choice
// survives reloads. Returns false immediately when muted or when Web
// Audio is unavailable so callers can no-op silently.

const MUTE_KEY = "bailey_confetti_muted";

export function isConfettiMuted() {
  try {
    return localStorage.getItem(MUTE_KEY) === "1";
  } catch {
    return false;
  }
}

export function setConfettiMuted(muted) {
  try {
    if (muted) localStorage.setItem(MUTE_KEY, "1");
    else localStorage.removeItem(MUTE_KEY);
  } catch {
    // ignore
  }
}

let _ctx = null;
function _getCtx() {
  if (_ctx) return _ctx;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  try {
    _ctx = new AC();
  } catch {
    _ctx = null;
  }
  return _ctx;
}

function _ring(ctx, freq, startAt, duration = 1.2, gain = 0.12) {
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.type = "sine";
  osc.frequency.setValueAtTime(freq, startAt);
  g.gain.setValueAtTime(0, startAt);
  g.gain.linearRampToValueAtTime(gain, startAt + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);
  osc.connect(g).connect(ctx.destination);
  osc.start(startAt);
  osc.stop(startAt + duration + 0.05);
}

// Play the two-note bell. Returns true if playback started, false if
// muted or unsupported. Safe to call from any event handler.
export function playConfettiChime() {
  if (isConfettiMuted()) return false;
  const ctx = _getCtx();
  if (!ctx) return false;
  // Some browsers create the context suspended until user interaction.
  if (ctx.state === "suspended") {
    ctx.resume().catch(() => {});
  }
  const now = ctx.currentTime;
  _ring(ctx, 1046.5, now, 1.1, 0.12);        // C6
  _ring(ctx, 1318.5, now + 0.09, 1.3, 0.10); // E6 slightly later for a bell shimmer
  return true;
}
